import { FExprAgg, FExprScalar } from './Formula/FormulaExpr';
import { Pipeline } from './Formula/Parser/Visitor';
import { Validator } from './Formula/Validator';
export var FormType;
(function (FormType) {
    FormType["GENERIC"] = "GENERIC";
    // Specified Types
    FormType["FIELD"] = "FIELD";
    FormType["AGGFUNC"] = "AGGFUNC";
    FormType["NTILEFUNC"] = "NTILEFUNC";
    FormType["DATEFUNC"] = "DATEFUNC";
})(FormType || (FormType = {}));
export class Formula {
    constructor(tree, compiler) {
        this._tree = tree;
        this._compiler = compiler;
        this._expr = null;
    }
    get tree() {
        return this._tree;
    }
    get source() {
        return this.tree.source;
    }
    get compiler() {
        return this._compiler;
    }
    get expr() {
        return this.compile();
    }
    get isValid() {
        return this.validate().length === 0;
    }
    get dataFields() {
        this.compile();
        return this.compiler.dataFields;
    }
    validate() {
        const validator = new Validator(this.compiler.fieldResolver, this.compiler.funcResolver);
        const pipeline = new Pipeline();
        pipeline.addVisitor(validator.fieldResolver);
        pipeline.addVisitor(validator.funcResolver);
        pipeline.addVisitor(validator);
        pipeline.visitAllDepthFirst(this.tree);
        return validator.errors;
    }
    compile() {
        if (this._expr === null) {
            const compiler = this.compiler;
            const pipeline = new Pipeline();
            pipeline.addVisitor(compiler.fieldResolver);
            pipeline.addVisitor(compiler.funcResolver);
            pipeline.addVisitor(compiler.typeResolver);
            pipeline.addVisitor(compiler);
            pipeline.visitAllDepthFirst(this.tree);
            if (compiler.isScalar) {
                this._expr = new FExprScalar(compiler.returnType, compiler.final);
            }
            else if (compiler.isAggregate) {
                this._expr = new FExprAgg(compiler.returnType, compiler.init, compiler.step, compiler.final);
            }
        }
        return this._expr;
    }
}
